import React, { useState } from "react";
import { Box, Button, Divider, Text, Title, Tooltip } from "@mantine/core";
import ButtonSvg from "../assets/img/more.svg";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { Menu, rem } from "@mantine/core";
interface Props {
  name: string;

  info: string;
  title: string;
  src: any;
  buttonclick: any;
  edit: any;
  deleteClick: any;
  status: string;
  connectButton: any;
}

const ReusableCard: React.FC<Props> = ({
  name,
  info,
  title,
  src,
  buttonclick,
  edit,
  deleteClick,
  status,
  connectButton,
}) => {
  const truncatedInfo = info?.length > 110 ? `${info?.slice(0, 110)}...` : info;
  const truncatedName = name?.length > 25 ? `${name?.slice(0, 25)}...` : name;
  return (
    <Box
      sx={{
        padding: "16px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        width: "520px",
        height: "188px",
        display: "flex",
        alignItems: "center",

        "&:hover": {
          border: "none",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: "16px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "auto",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Box sx={{ display: "flex", gap: "12px" }}>
            <Tooltip
              label={name}
              multiline
              width={300}
              withArrow
              position="top-start"
              transitionProps={{ duration: 200 }}
              color="gray"
            >
              <Text
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "'Montserrat', sans-serif', sans-serif",
                }}
              >
                {" "}
                {truncatedName}
              </Text>
            </Tooltip>

            <Title
              sx={{
                color:
                  status === "Connected"
                    ? "var(--Success-500, #2C9D08)"
                    : "#818999",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                padding: "6px 14px",

                backgroundColor: status === "Connected" ? "#E7FFE5" : "#EDEDED",
                borderRadius: "37px",
              }}
            >
              {status}
            </Title>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignContents: "flex-end",
              cursor: "pointer",
            }}
          >
            <Menu>
              <Menu.Target>
                <img src={ButtonSvg} alt="ButtonSvg" style={{maxHeight:"20px"}}/>
              </Menu.Target>
              <Menu.Dropdown
                sx={{
                  borderRadius: "8px",
                  transform: "translateX(calc(100% - 309px))",
                }}
              >
                <Menu.Item component="a" onClick={edit}>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "183px",
                      height: "43px",
                      fontWeight: 600,
                      fontSize: "14px",
                      justifyContent: "center",
                    }}
                  >
                    <IconEdit
                      style={{
                        width: rem(18),
                        height: rem(18),
                        marginRight: "8px",
                      }}
                    />
                    Edit
                  </Box>
                </Menu.Item>
                <Divider />
                <Menu.Item onClick={deleteClick}>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "183px",
                      height: "43px",
                      fontWeight: 600,
                      fontSize: "14px",
                      justifyContent: "center",
                    }}
                  >
                    <IconTrash
                      style={{
                        width: rem(18),
                        height: rem(18),
                        marginRight: "8px",
                      }}
                    />{" "}
                    Delete
                  </Box>
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Box>
        </Box>
        <Box
          sx={{
            marginBottom: "16px",
            fontWeight: 400,
            fontSize: "14px",
            fontFamily: "'Montserrat', sans-serif', sans-serif",
            marginRight: "50px",
           }}
        >
          <Tooltip
            multiline
            width={300}
            withArrow
            position="top-start"
            transitionProps={{ duration: 200 }}
            label={info}
            color="gray"
          >
            <Text
              sx={{
                padding: "0px 30px 0px 0px",
                marginRight: "30px",
                wordBreak: "break-word",
                height:"45px"
              }}
            >
              {truncatedInfo}
            </Text>
          </Tooltip>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              height: "40x",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignContents: "flex-end",
                marginRight: "24px",
                height: "32px",
              }}
            >
              <img src={src} alt="logo" style={{width: '100px'}}/>
            </Box>
            <Box>
              <Title
                sx={{
                  color: "#0570DE",
                  fontFamily: "Montserrat",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  backgroundColor: "#F5FAFF",
                  borderRadius: "24px",
                  padding: "6px 12px",
                }}
              >
                {title}
              </Title>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignContents: "flex-end" }}>
            {/* <Button
              sx={{
                backgroundColor: "#1B75BC",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "20px",
              }}
              onClick={buttonclick}
            > */}
            {connectButton()}
            {/* </Button> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReusableCard;
